import React from 'react';

const FormButtons = ({
  onFormClick,
  buttonLabel,
  buttonCopy,
  onSignUp,
  buttonHint,
  isFormValid,
  isSignUpSuccessful,
}) => {
  let disableButton = !isFormValid && !isSignUpSuccessful;

  return (
    <div className='flex flex-col lg:justify-end mt-8'>
      {buttonLabel && (
        <div
          dangerouslySetInnerHTML={{ __html: buttonLabel }}
          className='font-semibold pl-0 block z-10 whitespace-normal'
        />
      )}
      {buttonHint && (
        <div
          dangerouslySetInnerHTML={{ __html: buttonHint }}
          className='font-semibold pl-0 mb-8 block z-10 whitespace-normal'
        />
      )}

      <div className='flex space-x-5 ml-0'>
        {buttonCopy.map((button) =>
          button.text !== 'Next' ? (
            button.type === 'submit' || button.type === 'login' ? (
              <button
                key={button.text}
                className={`py-2 px-5 text-white bg-dms-primary text-lg font-medium cursor-pointer transition duration-100 rounded z-10 ${
                  button.type === 'submit' ? 'mt-12' : '-mt-4'
                }  ${
                  disableButton
                    ? ' opacity-50 cursor-not-allowed pointer-events-none hover:'
                    : 'hover:text-dms-primary hover:bg-white hover:border-dms-primary hover border-2'
                }`}
                type={button.type}
                onClick={button.type === 'submit' ? onSignUp : onFormClick}
                value={button.text.toLowerCase()}
              >
                {button.text}
              </button>
            ) : (
              <button
                key={button.text}
                className={`py-2 px-5 text-dms-primary border-2 border-dms-primary text-lg font-medium cursor-pointer transition duration-100 rounded z-10 w-40 hover:bg-dms-primary hover:text-white mt-0`}
                type={button.type}
                onClick={onFormClick}
                value={button.text.toLowerCase()}
              >
                {button.text}
              </button>
            )
          ) : (
            <button
              key={button.text}
              className={`py-2 px-5 text-white bg-dms-primary text-lg font-medium cursor-pointer transition duration-100 rounded z-10 w-40 mt-12 ${
                disableButton
                  ? ' opacity-50 cursor-not-allowed pointer-events-none hover:'
                  : 'hover:text-dms-primary hover:bg-white hover:border-dms-primary hover border-2'
              }`}
              type={button.type}
              onClick={onFormClick}
              value={button.text.toLowerCase()}
            >
              {button.text}
            </button>
          )
        )}
      </div>
    </div>
  );
};

export default FormButtons;
